import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './login.component';

export const routes: Routes = [
  {
    path: 'login', component: LoginComponent, data: { title: 'Home-Leite - Login' }
  }
];

export const LoginRoutes: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
